const supportEmail = "help@pazien.com";

const email = `<a href='mailto:${supportEmail}'>${supportEmail}</a>`;

const strings = {
    notAvailableValue: "n/a",
    notAvailableValueUpper: "N/A",
    notAvailableValueLong: "Not available",
    unknown: "unknown",
    other: "Other",
    // eslint-disable-next-line sentence-case/sentence-case
    unidentified: "Unmapped MIDs",
    add_metric: "Add a metric",
    all: "All",
    allLevels: "All levels",
    amount: "Amount",
    rate: "Rate",
    count: "Count",
    compareSelected: "Compare selected",
    totalTransactions: "Total transactions",
    sales: "Sales",
    refunds: "Refunds",
    salesAndRefunds: "Sales and refunds",
    salesAndRefundsPayouts: "Sales, refunds and payouts",
    chargebacks: "Chargebacks",
    chargebacksAmount: "Chargebacks amount",
    chargebacksCount: "Chargebacks count",
    fees: "Fees",
    feesAmount: "Fees amount",
    misc: "Misc.",
    settlementAmount: "Settlement amount",
    purchaseAmount: "Transaction amount",
    totalAmount: "Total amount",
    totalCount: "Total count",
    totalSales: "Total sales",
    totalRefunds: "Total refunds",
    salesAmount: "Sales amount",
    salesCount: "Sales count",
    onSalesOf: "on sales of",
    onFeesOf: "on fees of",
    totalFeesWithTaxes: "TOTAL FEES and TAXES",
    totalFeesAndTaxes: "Total fees and taxes",
    taxesAndFees: "Fees",
    taxIndicator: "Tax indicator",
    taxRate: "Tax rate",
    taxes: "Taxes",
    taxDescription: "Tax description",
    taxableAmount: "Taxable amount",
    taxAmount: "Tax amount",
    refundsAmount: "Refunds amount",
    refundsCount: "Refunds count",
    refundRate: "Refund rate",
    averageTicket: "Average ticket",
    averageOrderValue: "Avg. sale amount",
    sale: "Sale",
    refund: "Refund",
    avgSale: "Avg. sale",
    avgRefund: "Avg. refund",
    averageRefundValue: "Avg. refund amount",
    averageDeclineValue: "Avg. decline amount",
    averageChargebackValue: "Avg. chargeback amount",
    classicDate: "Classic",
    date: "Date",
    netCashFlow: "Net cash flow",
    invoiceDate: "Invoice date",
    presentementDate: "Presentment date",
    name: "Name",
    day: "Day",
    provider: "Provider",
    provider_path: "Provider path",
    provider_paths: "Provider paths",
    currency: "Currency",
    attempt_group: "Attempt group",
    attempt_groups: "Attempt groups",
    billingDescriptor: "Billing descriptor",
    billingDescriptors: "Billing descriptors",
    reasonCategory: "Reason category",
    feeCode: "Fee code",
    mcc: "MCC",
    mccTooltip: "Merchant category code",
    mccs: "MCCs",
    avs_response_code: "AVS response code",
    cvv2_response_code: "CVV2 response code",
    issuingBank: "Issuing bank",
    transactionCost: "Transaction cost (C)",
    options: "Options",
    cancel: "Cancel",
    "export": "Export",
    analyze: "Analyze",
    transactionDate: "Transaction date",
    settlementDate: "Settlement date",
    settlementStatus: "Settlement status",
    dataReadiness: "Data status",
    dataReady: "Ready",
    dataProcessing: "Pending",
    dataError: "Missing or in error",
    fxrate: "FX rate",
    feeActivityDate: "Activity date",
    orderDate: "Order date",
    chargebackDate: "Chargeback date",
    chargebackStlDate: "Chargeback settlement date",
    nullRateTableCell: "-",
    emptyTableCell: "--",
    cardNumber: "Account",
    table: "Table",
    chart: "Chart",
    month: "Month",
    week: "Week",
    freq: {
        day: "Group by day",
        week: "Group by week",
        month: "Group by month"
    },
    transactions: "Transactions",
    stl_currency: "Settlement currency",
    stl_currency_plural: "Settlement currencies",
    approvals: "Approvals",
    soft_declines: "Declines (soft)",
    hard_declines: "Declines (hard)",
    rejects: "Rejects",
    unknown_declines: "Unknown",
    auths_tests_include: "Include test auths",
    auths_tests_exclude: "Exclude tests auths",
    auths_tests_only: "Test auths only",
    // eslint-disable-next-line sentence-case/sentence-case
    pivot_table_rows_columns_filters: "Rows, Columns, and Filters options",
    pivot_table_values: "Values options",
    clear: "Clear",
    reset: "Reset",
    clearAll: "Clear all",
    viewAll: "View all",
    errorFetchingSettlementStatus: "There was an error fetching settlement status",
    
    netSettledSales: "Net settled sales",
    
    timeoutLoginMessage: "For your security, you have been logged out due to 15 minutes of inactivity",
    sessionExpireTitle: "Your session will time out in two minutes",
    sessionExpireInfo: "For security purposes, we automatically sign you out after {{ data.minutes }} minutes of inactivity.",
    sessionChoice: "What would you like to do?",
    
    gotIt: "OK, got it",
    
    pazienUser: "Pazien user",
    userManagement: "User management",
    allMerchants: "All merchants",
    recentMerchants: "Recent",
    allGroups: "All groups",
    allUsers: "All users",
    newUser: "New user",
    newGroup: "New group",
    groupName: "Name of the group",
    groupDescription: "Description",
    createGroup: "Create group",
    updateGroupSuccess: "Group has been successfully updated",
    updateUserSuccess: "User has been successfully updated",
    createUserSuccess: "User has been successfully created",
    setPermissions: "Set permissions",
    setProviders: "Set providers",
    addUsers: "Add users",
    groupUsers: "Users in this group",
    alacarte: "À la carte",
    addAll: "Add all",
    addOne: "Add",
    allPermissions: "All permissions",
    addAllUser: "Add all permissions<br/>to this user",
    allProviders: "All providers",
    addAllProvidersUser: "Add all providers<br/>to this user",
    addOneUser: "Add to user",
    removeOne: "Remove",
    removeAll: "Remove all",
    enabledByParent: "Enabled by parent selection",
    notAvailablePermission: "Not available in the current package. Contact your sales rep for more info.",
    viewTransactionsDisabled: "You do not have permission to view transaction details. If you believe this is an error, please contact your admins.",
    accessDenied: "Access denied",
    role: "Role",
    admin: "Admin user",
    addAdmin: "Add user to the admin group",
    createUser: "Create user",
    updateUser: "Update user",
    showInactiveUsers: "Display deactivated users",
    permissions: "Permissions",
    signsInUsing: "Signs in using",
    userGroups: "User groups",
    enabledInGroup: "Enabled as part of a group",
    enabledAsAdmin: "Enabled as part of admin role",
    addOneToUser: "Add",
    addBU: "Add this BU and all of its children.",
    removeBU: "Remove this BU and all of its children.",
    buSelected: "The user has access to this BU and all its children.",
    buDescendants: "The user has access to one or more of this BU's children.",
    collapseAllBUs: "Collapse all",
    onlyAddedBUs: "Show only added BUs",
    confirmGroupDelete: "Are you sure you want to delete this group?",
    createGroupLink: "Create a group",
    errorFetchingUserPrereqs: "There was an error fetching user management prerequisites",
    noUsersForMerchant: "There are no users assigned to this merchant or matched your search criteria",
    noUsersGroup: "This group does not contain any users yet",
    calcFieldsLock: "<i class=\"fas fa-lock pz-popover\" role=\"button\" data-html=\"true\" data-toggle=\"popover\" data-trigger=\"hover\" data-placement=\"top\" data-content=\"Calculated rates are available with the Pazien Pro package\" aria-hidden=\"true\"></i>",
    lockIconTables: "<div class='center'><i class='fas fa-lock' style='color: #C4C4C4;'></i></div>",
    
    required: "Required field",
    
    authCount: "Authorizations count",
    authAmount: "Authorizations amount",
    declinesCount: "Declines count",
    declinesAmount: "Declines amount",
    
    declines: "Declines",
    softDeclines: "Soft declines",
    hardDeclines: "Hard declines",
    reject: "Rejects",
    unknownDeclines: "Unknown",
    
    description: "Description",
    adjType: "Adjustment type",
    paidTo: "Paid to",
    
    allColumns: "All columns",
    
    originalTxnOrderId: "Original transaction order ID",
    
    page_dashboard: "Dashboard",
    page_search: "Search",
    page_reconciliation: "Reconciliation",
    page_reports: "Reports",
    page_analytics: "Analytics",
    page_fraud: "Fraud tools",
    page_allfraud: "Reported fraud",
    page_psd2: "PSD2",
    page_authorizations: "Authorizations",
    page_cashflow: "Cash flow",
    page_chargebacks: "Chargebacks",
    page_fees: "Fees",
    page_sales_refunds: "Sales and refunds",
    page_downloads: "Downloads",
    page_development: "Development",
    page_userguide: "User guide",
    page_advanced_settings: "Advanced settings",
    page_benchmarks: "Benchmarks",
    
    permissions_validation_msg: "At least one permission from <strong>each</strong> of the below permission tabs is required for this user to sign into Pazien",
    
    // Dashboard
    allPayments: "All payments",
    
    learn: "Learn how to use features on this page",
    nolearn: "There are no cues available for this page",
    announcements: "Announcements",
    no_announcments: "No new announcements",
    
    reports_saveAs: "Save as",
    reports_save: "Save",
    reports_saved: "Saved",
    reports_saved_tooltip: "Saved",
    reports_save_tooltip: "Update your saved view with new search filters and view",
    reports_saveAs_tooltip: "Save your current filters and date range as a saved view to access later",
    reports_saveReport_title: "Save view",
    reports_date_caption: "Launch this saved view with the following date range:",
    reports_date_start_end: "<b>{{ data.start }}</b> to <b>{{ data.end }}",
    reports_date_rolling_30_days: "The last <b>rolling 30 days</b>",
    reports_date_current_month: "The <b>current month</b>",
    reports_date_last_month: "The <b>last month</b>",
    reports_date_previous_day: "The <b>previous day</b>",
    reports_date_from_start_to_current: "From <b>{{ data.start }}</b> rolling to the <b>current day</b>",
    reports_save_success_message: "Your report is successfully saved",
    reports_save_error_message: "There was an error saving your view",
    reports_load_error_message: "There was an error loading your view",
    reports_name: "Name",
    reports_name_placeholder: "e.g. {{ data.date }} {{ data.section }}",
    reports_error_name_required: "Name is required",
    reports_save_button: "Save view",
    reports_empty_header: "Save the views you use most often",
    reports_empty_step1: "Go to any analytics page",
    reports_empty_step2: "Click the <i class='fal fa-bookmark'></i> Save As icon found at the right-hand side of the filter bar",
    reports_delete_report_tooltip: "Delete a saved view",
    reports_open_report_tooltip: "Open a saved view",
    reports_delete_confirm: "Are you sure you want to delete this saved view?",
    reports_delete_error: `There was an error deleting your saved view. Please try again or contact us at ${email}`,
    reports_delete_success: "Your saved view has been successfully deleted",
    reports_header_viewall_tooltip: "Saved views",
    reports_header_close_tooltip: "Close this saved view",
    reports_recently_viewed: "Recently viewed",
    navigate_pack: "Navigate back",
    
    declineRate: "Decline rate",
    
    dashboard: {
        authorizations: "Authorizations",
        approvalRate: "Approval rate",
        rate: "Rate",
        approvals: "Approvals",
        tabTitle: "Dashboard",
        netApprovalRate: "Net approval rate",
        cashFlow: "Cash flow",
        youPaid: "You paid",
        grossSales: "Gross sales",
        widgets: {
            approval_rate: {
                after: "After",
                attempts: "Attempted",
                approvals: "Approved",
                self: "Approval rate"
            },
            decline_rate: {
                after: "After",
                attempts: "Attempts"
            },
            fees_rate: {
                feesPaid: "Fees paid"
            },
            refund_rate: {
                totalRefunds: "Total refunds"
            },
            rate_network: {
                received: "Received",
                disputedValue: "Disputed value",
                estimated: "Estimated",
                estimated_tooltip: "<b>Estimated chargeback rate</b>"
                + "<p>The network has not yet calculated a rate for this month. Pazien has forecasted a rate using the current"
                + " month's chargebacks received divided by last month's sales.</p>",
                received_tooltip: "<b>Received chargebacks</b><p>Total number of 1st chargebacks received during the selected date range</p>",
                disputedValue_tooltip: "<b>Disputed value</b><p>Total value of the 1st chargebacks received during the selected date range</p>"
            }
        },
        filters: {
            on: "This widget has 1 or more filters applied",
            conflict: "This widget's filters conflict with the page level filters"
        },
        viewMore: "View more >"
    },
    login: {
        troubleSignIn: "Trouble signing in?",
        errors: {
            emailEmpty: "Enter your email address.",
            passEmpty: "Enter your password",
            resetError: `There was an error requesting password reset. Please try again or contact us at ${email}`,
            lockError: `There was an error requesting user lock. Please try again or contact us at ${email}`,
            activationEmailError: `There was an error sending activation email. Please try again or contact us at ${email}`,
            resetTokenExpired: "Your request to reset the password has expired. Please <a href='/merchant/reset'>submit</a> another request."
        },
        rememberMe: "Remember me",
        signIn: "Sign in",
        password: "Password",
        newPassword: "New password",
        email: "Email",
        signInTitle: "Sign into your account",
        signInAdminTitle: "Sign into your administrator account",
        rememberMeTooltip: "Check this box to securely remember your email on this computer",
        copyright: `&copy; ${new Date().getFullYear()} Pazien, Inc. All rights reserved.`,
        welcome: "Hi {{- data.name }}, welcome to Pazien!",
        welcomeBack: "Welcome back, {{- data.name }}",
        welcomeToPazien: "Welcome to Pazien!",
        thisIsNotMe: "Sign in with a different account",
        next: "Next",
        loginHistory: "Log in history",
        passExpired: "Hi {{- data.name }}, your password has expired.<br/>Please update it now.",
        passReset: "Enter a new password to complete your password reset.",
        newPasswordPrompt: "Please create a new password",
        showPassword: "Show password",
        showPasswordTooltip: "Unmask password",
        saveNewPassword: "Save new password",
        validator: {
            title: "New password must:",
            charactersLimit: "Be at least 8 characters",
            alphabetical: "Have at least one alphabetic character",
            number: "Have at least one number",
            different: "Be different from your last 10 passwords",
            email: "Be different from your email"
        },
        resetPassword: "Forgot password?",
        noEmailAccess: "I don't have access to my email",
        resetRequestedSuccess: "Check your email for instructions on completing your password reset",
        cantLogin: `<p style='margin-top: 10px;'>If you are having difficulty signing into your account, or are unable to receive a password reset, please contact Pazien at ${email} and we'll help you out.</p>
                    <p style='margin: 20px 0;'>
                      <sup>*</sup>Please note that if you use Pazien through your payment provider, you will need to log in with single sign-on through their Service Portal.
                    </p>`
        
    },
    common: {
        pageTitlePrefix: "Pazien",
        defaultPageTitle: "Merchant",
        errors: {
            title: "Oops...",
            message: "Something went wrong",
            internal: `There was an internal error. Please try again or contact us at <a href='mailto:${supportEmail}'>${supportEmail}</a>`
        },
        sort: {
            name: "Sort",
            by: {
                time: {
                    ascending: "Ascending (new - old)",
                    descending: "Descending (old - new)"
                },
                amount: {
                    ascending: "Ascending (more - less)",
                    descending: "Descending (less - more)"
                },
                alphabetical: {
                    ascending: "Ascending (A - Z)",
                    descending: "Descending (Z - A)"
                },
                general: {
                    ascending: "Ascending",
                    descending: "Descending"
                }
            }
        },
        filter: {
            select: "Show"
        },
        "export": {
            content: "Content",
            allTransactions: "All transactions",
            allSummaries: "All summaries",
            file: {
                label: "File name",
                format: "File format"
            }
        }
    },
    // bu picker
    exportBUTooltip: "Export business unit hierarchy and MID mappings",
    managerBUTooltip: "Manage business unit hierarchy and MID mappings",
    
    // All txns
    paymentMethodTooltip: "The method of payment used by the customer, e.g., Visa, MasterCard, PayPal, etc",
    cardTypeTooltip: "The specific type of card used by the customer, e.g., credit, debit, etc",
    accountTooltip: "The masked account number of the customers card. Includes the first 6 and last 4 only.",
    issuingBankTooltip: "Name of the bank based on BIN",
    issuingCountryTooltip: "Country of the bank based on BIN",
    midTooltip: "The unique number assigned to the MID",
    // eslint-disable-next-line sentence-case/sentence-case
    companyidTooltip: "Company ID",
    fxrateTooltip: "FX rate",
    
    // Sales and refunds txns
    typeTooltip: "Identifies the transaction as a sale or a refund",
    transactionDateTooltip: "The date the provider receives the transaction. aka Activity date. This should match closely to the Order date",
    settlementDateTooltip: "The date the provider settles the transaction",
    orderDateTooltip: "The date of the order according to the Merchant's OMS, if available",
    orderIdTooltip: "Unique ID the merchant created for the order",
    purchaseAmountTooltip: "The amount the customer paid or was refunded",
    settlementAmountTooltip: "The amount settled by the provider",
    acquirerTooltip: "The provider settling the amount",
    txnIdTooltip: "The unique ID created by the provider to identify the sale or refunded transaction",
    airlineTicketToolTip: "Airline ticket number",
    receiptNumberToolTip: "Receipt number",
    arnSettlementsTooltip: "A unique acquirer reference number assigned to the lifecycle of the transaction",
    
    entryMethodTooltip: "How the account information was provided",
    authCodeTooltip: "A reference number the provider stamps on an authorization",
    authMethodTooltip: "How the account holder was authenticated",
    terminalTypeTooltip: "If a physical terminal existed and if it was attended",
    fundsTransferIdTooltip: "An ID stamped by the provider on a funds transfer",
    transactionSrc: "Transaction source",
    transactionSrcTooltip: "How a transaction occurred",
    
    // Chargebacks txns
    chargebackDateTooltip: "The date the dispute is received by the acquirer, or when the merchant challenges",
    disputeAmountTooltip: "The settled amount being disputed or challenged",
    chbkProviderTooltip: "The acquiring bank processing the dispute or challenge",
    disputeIdTooltip: "Unique ID assigned to each state. aka. Case number.",
    chbkStlDateTooltip: "Date the acquirer moves the money",
    arnTooltip: "ID assigned to life of dispute",
    lifecycleTooltip: "Identifies where this transaction is in the dispute lifecycle, e.g., 1st chargeback, re-presentment, exception, etc",
    reasonCategoryTooltip: "A general classification of the dispute reason, e.g., Fraud, Technical, Clerical, Quality",
    reasonCodeTooltip: "The reason code associated with the dispute or challenge",
    originalTxnIdTooltip: "Transaction ID of the original sale or refund associated with the dispute",
    originalTxnStlDateTooltip: "Date the original sale or refund was settled",
    originalTxnStlAmountTooltip: "Settlement amount of the original sale/refund",
    originalTxnOrderIdTooltip: "Merchant order ID associated with the original sale/refund",
    originalTxnActivityDateTooltip: "Date the provider received the settlement request. aka, Activity date",
    originalTxnPurchaseAmountTooltip: "Amount of the original transaction",
    duedate: "The deadline for responding to the dispute",
    // Fees
    descriptionTooltip: "Description of the fee that was charged, e.g., Interchange qualification program",
    feesProviderTooltip: "The name of the provider who charged this fee to the merchant",
    feeCodeTooltip: "If the fee has a specific, provider-assigned code associated with it",
    feeTypeTooltip: "The type of fee this is, e.g., Interchange, Assessment, Processor",
    totalFeeAmountTooltip: "The total amount of the fee charged to the merchant, calculated as (Transaction count * Transaction cost) + (Transaction amount * Rate)",
    invoiceDateTooltip: "The date the bill is sent to the merchant",
    feesActivityDateTooltip: "The last day of the date range in which the fees reside in. aka, billing period end date",
    feeSettlementDateTooltip: "The date the money is moved to the provider",
    feeTxnCountTooltip: "The number of transactions tied to this fee, if applicable",
    feeTxnAmountTooltip: "The sum amount of the transactions tied to this fee, if applicable",
    feeTxnCostTooltip: "The cost per transaction, if applicable",
    feeTxnRateTooltip: "The rate charged against the total transaction amount, if applicable",
    feeMidTooltip: "The unique number assigned to the MID associated with this fee, if available.",
    taxesTooltip: "Taxes (e.g. VAT, sales tax) collected by providers for services rendered.",
    
    // Auth
    authTransactionDateTooltip: "The date the provider processes a response for the transaction.",
    authOrderDateTooltip: "The date the merchant sends the sale or refund to the provider for authorization.",
    authPurchaseAmount: "The presentment amount. i.e, The amount the customer paid.",
    authProviderTooltip: "Name of the provider processing the authorization.",
    authProviderPathTooltip: "Order of providers this transaction was processed by.",
    authTransactionIdTooltip: "The unique ID assigned to the transaction by the provider",
    authAttemptTooltip: "Identifies which attempt (first, second, third, etc) this transaction is in the retry cycle.",
    authResponseTypeTooltip: "Identifies if the transaction was approved, declined, or rejected by the provider.",
    authPazienResponseCode: "Pazien's normalized numeric code associated with the response, e.g., D212.",
    authPazienResponseMessage: "Pazien's normalized qualitative description of the response code, e.g. Do not honor",
    authOrderIdTooltip: "A unique ID provided by the merchant",
    
    // FRAUD
    fraud: "Fraud",
    fraudOriginalTxnActivityDateTooltip: "The date of the original sale",
    fraudOriginalTxnStlDateTooltip: "The date the original transaction was settled by the acquirer",
    fraudActivityDateTooltip: "The date the transaction was reported as fraud",
    fraudOriginalTxnStlAmountTooltip: "The amount originally settled by the acquirer",
    fraudReasonCodeTooltip: "Pazien's normalized fraud response message",
    fraudTransactionSrcTooltip: "The channel through which a transaction came",
    fraudOriginalTxnReasonCode: "The response code as originally reported by the provider",
    // eslint-disable-next-line sentence-case/sentence-case
    fraudOriginalTxnID: "Transaction ID",
    fraudThreshold: "vs. Defined fraud threshold",
    fraudThresholdLegend: "Fraud rate threshold",
    fraudRateAmount: "Fraud rate and amount",
    fraudRate: "Fraud rate",
    fraudPriceBand: "Price band",
    fraudGrossSalesAmount: "Gross sales amount",
    fraudCardTitleAmount: "Fraud amount by",
    fraudCardTitleRateAndAmount: "Fraud rate and amount by",
    threshold: "Threshold",
    
    // misc
    miscProviderTooltip: "The acquiring bank processing the credit or debit",
    miscSettlementDateTooltip: "The date the provider settles the debit or credit",
    miscTransactionDateTooltip: "The date the provider receives the credit or debit",
    miscDescriptionTooltip: "Description of the credit or debit",
    
    search: {
        validationMsg: "At least one primary search field is required",
        nolower: "No lower limit",
        noupper: "No upper limit",
        labelsuffix: "currency and amount",
        notxnsfound: "No transactions found",
        viewing: "Viewing transactions"
    },
    reconciliation: {
        // eslint-disable-next-line sentence-case/sentence-case
        transactionID: "Transaction ID",
        accountNumber: "Account",
        type: "Type",
        flagged: "Flagged",
        status: "Status",
        notFlagged: "Not flagged",
        filterByFlagging: "Filter by flagging status",
        unflagTooltip: "Unflag",
        flagTooltip: "Flag for followup",
        filterTooltip: "Filter by reconciled status",
        unreconcileTooltip: "Unreconcile from bank",
        reconcileTooltip: "Reconcile to bank",
        reconciledTooltip: "Reconciled to bank",
        unreconciledTooltip: "Not reconciled",
        // eslint-disable-next-line sentence-case/sentence-case
        orderID: "Order ID",
        airlineticket: "Airline ticket number",
        receiptnumber: "Receipt number",
        unreconcile_title: "Unreconcile this",
        unreconcile_confirm: "Unreconcile it",
        unreconcile_success: "Your settlement has been successfully unreconciled.",
        unreconcile_error: "There was an error sending your request. Please try again or contact us."
    },
    topbar: {
        toggle: "Toggle navigation",
        hi: "Hi,",
        menu: {
            notifications: "Notifications",
            sign_out: "Sign out",
            stop_mimicking: "Stop mimicking"
        }
    },
    
    approvalRateBy: "Approval rate by",
    declinesBy: "Declines by",
    cashFlowBy: "Cash flow by",
    feesBy: "Fees by",
    chargebacksBy: "Chargebacks by",
    salesRefundsBy: "Sales and refunds by",
    
    banks_plural: "banks",
    countries_plural: "countries",
    
    authsByAttempt: "Authorizations by attempt",
    
    analytics: {
        performanceCards: "Performance cards",
        approvalRate: "Net approval rate",
        backToAll: "Back to all cards",
        remove: "Remove",
        view_all: "View all",
        
        authorizations: {
            name: "Authorizations",
            attempts: "Attempts",
            initialAttempts: "Initial attempts",
            allAttempts: "All attempts",
            retriesAttempts: "Retried attempts",
            all: "All",
            initials: "Initials",
            retries: "Retries",
            testAuths: "Test auths",
            exclude: "Exclude",
            include: "Include",
            authAttempts: "Authorization attempts:",
            approvalRateBy: "Approval rate by",
            approvals: "Approvals",
            declines: "Declines",
            unableToBreakOut: "Unable to break out authorizations by attempt",
            unableToBreakOutBody: `Not all your providers offer enough detail to properly break out total authorizations by attempt.
                                         If you need to monitor retries, we suggest <b>drilling into each provider separately</b>.`
        },
        
        declines: {
            name: "Declines",
            soft: "Soft",
            hard: "Hard",
            softDeclines: "Soft declines",
            hardDeclines: "Hard declines",
            reject: "Rejects",
            unknown: "Unknown",
            rejectDeclines: "Rejects",
            declineRate: "Decline rate",
            vsAll: "vs. ALL DECLINES",
            netDeclineRate: "Net decline rate"
        },
        
        cashFlowPage: {
            name: "Cash flow",
            top: "The top",
            settled: "Net settled cash",
            settledAmount: "Net settled",
            cashIn: "Cash in",
            cashInTooltip: "Your sales",
            cashOut: "Cash out",
            cashOutTooltip: "Your refunds, fees, and chargebacks"
        },
        feesPage: {
            name: "Fees",
            feesPaid: "Fees paid",
            top: "The top",
            feesTotal: "How much did you pay in fees?",
            feeDetail: "Fee detail",
            totalFeesCard: "Total fees",
            processorFees: "Provider fees",
            providerFees: "Provider fees",
            interchangeFees: "Interchange fees",
            assessmentFees: "Assessment fees",
            feeCategory: "Fee category",
            invoiceNo: "Invoice",
            totalCharges: "Total charges",
            totalChargesFormula: "Total charges<br/>(CxU)+(AxR)",
            
            processorRate: "Effective rate of provider fees",
            interchangeRate: "Effective rate of interchange fees",
            assessmentRate: "Effective rate of assessment fees",
            
            processor: "Provider",
            interchange: "Interchange",
            assessment: "Assessment",
            scheme: "Scheme",
            chargebacks: "Chargebacks",
            salesSettled: "Sales settled",
            salesProcessed: "Sales processed",
            provider: "Provider",
            settledAmount: "Net settled",
            cashIn: "Cash in",
            cashOut: "Cash out",
            netEffectiveRate: "Net effective rate",
            grossEffectiveRate: "Gross effective rate",
            effectiveRate: "Effective rate",
            effectiveRates: "Effective rates",
            feeAmount: "Fee amount",
            providerSalesPopover: `Sales used to calculate the effective rate. Gateway sales are displayed to calculate the effective rate,
                                     but are not included in settled sales as settled  sales are shown with the associated acquirer.`,
            count: "Txn count (C)",
            transactionsCount: "Transaction count (T)",
            unitFee: "Unit fee (U)",
            amount: "Txn amount (A)",
            transactionsAmount: "Transaction amount (A)",
            rate: "Rate (R)",
            totalCharge: "Total charge (TC)",
            totalFeeAmount: "Total fee amount = (T * C) + (A * R)",
            granularPopover: "To get more granular with your fees, add a provider filter"
        },
        
        chargebacks: {
            name: "Chargebacks",
            chargebackCount: "Chargeback count",
            chargebackAmount: "Chargeback amount",
            chargebackRate: "Chargeback rate",
            totalChargebacks: "Total chargebacks",
            fraud: "Fraud",
            quality: "Quality",
            technical: "Technical",
            clerical: "Clerical",
            cbRate: "CB rate",
            unableToBreakOut: "Unable to break out CB lifecycle information",
            unableToBreakOutBody: `Not all your providers offer enough detail to properly break out lifecycle states.
                                     If you need to monitor the chargeback lifecycle, we suggest <b>drilling into each provider separately</b>.`,
            dateReceived: "Date received",
            disputeAmount: "Dispute amount",
            authDate: "Auth date",
            replyByDate: "Reply by date",
            arn: "ARN",
            state: "State",
            // eslint-disable-next-line sentence-case/sentence-case
            disputeId: "Dispute ID",
            totalSalesRate: "Sales used to calculate the chargeback rate."
        },
        
        settlements: {
            name: "Sales and refunds",
            by: "Sales and refunds by"
        },
        refundsPage: {
            name: "Refunds",
            by: "Refunds by"
        },
        
        approvals: "Approvals",
        all_authorizations: "All authorizations",
        
        percentOfAllAuths: "% of all authorizations",
        percentOfAllDeclines: "% of all declines"
    },
    
    allDeclines: "All declines",
    
    notifications: {
        inQueue: "In queue",
        download: "Download",
        alerts: "Alerts",
        reminders: "Reminders",
        downloads: "Downloads",
        noDownloads: "You have no new downloads",
        noAlerts: "You have no unread alerts",
        noReminders: "You have no new reminders",
        manageAlerts: "Add or manage alerts"
    },
    snapshots: {
        dialogHeader: {
            title: "Alert snapshot",
            previous: "PREV",
            next: "NEXT",
            countSeparator: "of"
        },
        dialogBody: {
            resolvedLink: "Mark as resolved",
            viewData: "View data"
        },
        dialogFooter: {
            msg: "Viewing this data will set the selected date range to"
        }
    },
    deleteConfirm: "Delete",
    downloads_all: "All downloads",
    downloadsConfirmDestroyText: "Are you sure you want to delete this file?",
    downloadsConfirmDestroyAllText: "Are you sure you want to delete <b>all</b> files?",
    downloadsDeleteConfirm: "Delete report",
    downloadsDeleteAll: "Delete all",
    
    users: "Users",
    groups: "Groups",
    preferences: {
        pageName: "Your account",
        unsavedChangesTitle: "Are you sure?",
        unsavedChanges: "You have unsaved changes. Do you want to leave and discard your changes or stay on this page?",
        leave: "Leave",
        alerts: {
            title: "Alerts",
            view: "View alerts",
            manage: "Manage"
        },
        profile: {
            basicInfo: "Basic info about you",
            firstName: "First name",
            lastName: "Last name",
            email: "Email",
            jobTitle: "Job title",
            successMessage: "Your profile changes have been saved.",
            errors: {
                network: "There was a network error saving changes to your profile. Please try again.",
                emptyFirstName: "Please fill first name field.",
                emptyLastName: "Please fill last name field.",
                emptyEmail: "Please fill email field.",
                emptyMerchantRef: "Please select at least one merchant for the user",
                updateEmail: "You cannot change the email address associated with your account. Contact Pazien to update your email."
            }
        },
        typeahead: {
            emptyMessage: "No results found matching current query",
            add: "Add a filter"
        },
        security: {
            change: "Change password",
            oldPassword: "Old password",
            showPasswords: "showPasswords",
            errors: {
                wrongPassword: "The email and password you entered don't match.",
                oldPasswordRequired: "Old password is required",
                unknownError: "Unknown error",
                emailNotFound: "Sorry, Pazien doesn't recognize that email.",
                lockedDueToFailedAttempts: "This account has been locked because of too many failed login attempts.",
                accountHasBeenLocked: "Your account has been locked",
                lockedExplanation: `For your security, we lock accounts following too many unsuccessful sign-in attempts within a 30 minute timespan.
                                    Please try again in 30 minutes or contact your admin to immediately unlock your account.`,
                locked90DaysExplanation: `For your security, we lock accounts that have been inactive for more than 90 days. For assistance,
                                          please contact your team admin or Pazien directly at ${supportEmail}.`
            }
        },
        bu_hierarchy: {
            title: "Business unit manager",
            newBU: "New business unit",
            rename: "Rename selected item",
            deleteItem: "Delete selected item",
            // eslint-disable-next-line sentence-case/sentence-case
            newMID: "New MID",
            undo: "Undo last action",
            move: "Move selected item(s)",
            createdBy: "Created by",
            warningTitle: "Permission present",
            permissionWarning: "There is a permission set on one or more nodes.",
            hideWarning: "Hide this warning for the remainder of the session.",
            unmappedWarningTitle: "Business units will be lost.",
            unmappedWarning: "This action will delete the selected business unit tiers and temporarily assign the MIDs to Unmapped MIDs. This action cannot be undone. Do you wish to continue?",
            unmappedAndPermissionWarningTitle: "Business units and permissions will be lost.",
            unmappedAndPermissionWarning: "This action will delete the selected business unit tiers and any user permissions associated with them, and temporarily assign the MIDs to Unmapped MIDs. This action cannot be undone. Do you wish to continue?"
        }
    },
    development: {
        datepicker: "Datepicker",
        advancedSettings: "Advanced settings",
        table: "Smart table"
    },
    defaultGroup: "Default group for new users",
    confirmMimicUser: "Are you sure you want to mimic this user?",
    confirmRemoveUser: "Are you sure you want to remove this user?",
    confirmReactivateUser: "Are you sure you want to reactivate this user?",
    confirmUnlockUser: "Are you sure you want to unlock this user?",
    confirmResetPasswordUser: "Are you sure you want to reset password for this user?",
    confirmResendActivationEmail: "Are you sure you want to send welcome email to this user?",
    send: "Send",
    noCreateEditUsersPermissions: "You do not have permissions to view or create users for this merchant",
    cannotSelectYourself: "You cannot select yourself for any changes.",
    cannotDeactivateSsoUser: "You cannot deactivate an SSO user",
    "delete": "Delete",
    deactivate: "Deactivate",
    deactivateUser: "Deactivate user",
    mimicUserButton: "Mimic this user",
    addUser: "Add user",
    editUser: "Edit user",
    unlockUser: "Unlock user",
    "continue": "Continue",
    resendActivationEmail: "Resend welcome email",
    reactivateUser: "Reactivate user",
    notificationUserPassReset: "Password is reset for {{- data.first_name }} {{- data.last_name }}. Email sent successfully.",
    notificationUserEmailRequested: "Activation email with instructions to {{- data.first_name }} {{- data.last_name }} sent successfully.",
    notificationUserAdded: "{{- data.first_name }} {{- data.last_name }} has been added as a user and will receive an email on setting a password",
    notificationUserAddedWithoutActivationEmail: "{{- data.first_name }} {{- data.last_name }} has been added as a user",
    neverLoggedIn: "User has never logged in",
    response: "Response",
    responseType: "Response type",
    responseCode: "Response code",
    responseCodes: "Response codes",
    // eslint-disable-next-line sentence-case/sentence-case
    companyid: "Company ID",
    mid: "MID",
    mids: "MIDs",
    MoM: "Month-over-month",
    DoD: "Day-over-day",
    WoW: "Week-over-week",
    perfCardRangeErrorBank: `There was an especially large number of active issuing banks within the selected date range which may take a few minutes to load. We suggest limiting your date range to less than 3 months.
                             <div class="retry-card" style="display: none;">I don't mind waiting, please continue to load the bank data</div>`,
    perfCardRangeError: `There was an especially large number of entries within the selected date range which may take a few minutes to load. We suggest limiting your date range to less than 3 months.
                             <div class="retry-card" style="display: none;">I don't mind waiting, please continue to load the bank data</div>`,
    perfCardError: `Oops. We were unable to load this card's data.
                             <br/>Please wait a moment and try refreshing.
                             <div class="retry-card">Refresh</div>`,
    alertSnapshotError: "Oops. We were unable to load this alert.",
    dashboardWidgetError: `Oops. We were unable to load this widget's data.
                             <br/>Please wait a moment and try refreshing.
                             <div class="retry-widget">Refresh</div>`,
    genericRefreshErrorStr: "<div class='generic-error-refresh'>Oops. We were unable to load this page. Please wait a moment and try refreshing. <div class=\"retry-page\">Refresh</div></div>",
    chargeback_states: {
        VI: {
            initial_dispute: "1st chargebacks",
            retrieval_request: "Retrieval requests",
            challenged_initial_dispute: "Representments",
            // eslint-disable-next-line sentence-case/sentence-case
            additional_dispute: "Pre-arbitration CBs",
            unknown: "Unknown"
        },
        MC: {
            initial_dispute: "1st chargebacks",
            retrieval_request: "Retrieval requests",
            challenged_initial_dispute: "2nd presentments",
            // eslint-disable-next-line sentence-case/sentence-case
            additional_dispute: "Arbitration (2nd CBs)",
            unknown: "Unknown"
        },
        DI: {
            initial_dispute: "1st chargebacks",
            retrieval_request: "Retrieval requests",
            challenged_initial_dispute: "Representments",
            // eslint-disable-next-line sentence-case/sentence-case
            additional_dispute: "Arbitration CBs",
            unknown: "Unknown"
        }
    },
    viewTransactions: "View transactions",
    hideTransactions: "Hide transactions",
    viewFeeDetails: "View fee details",
    hideFeeDetails: "Hide fee details",
    authorizations: "Authorizations",
    vi: "Visa",
    mc: "MasterCard",
    di: "Discover",
    sendActivationPopover: "The user will receive an email with instructions on setting his or her password",
    sendWelcomeEmail: "Send the user a welcome email",
    applyFilters: "Apply",
    clearFilters: "Clear all filters",
    saveFiltersTooltip: "Save this filter for future use",
    toggleEditorGUI: "Switch to explorer mode",
    toggleEditorText: "Switch to text editor mode",
    dropDownMode: "SELECTION MODE",
    dropDownModeQuick: "Quick add",
    dropDownModeMulti: "Multi-select",
    allFilters: "All filters",
    savedFilters: "Saved",
    savedFiltersStr: "Saved filters",
    recentFilters: "Recent",
    addAFilter: "Add a filter",
    include: "Include",
    exclude: "Exclude",
    none: "None",
    saveFiltersEmptyHeader: "Save the filters you use most often",
    saveFiltersEmptyStep1: "Add one or more filters to the filter bar",
    saveFiltersEmptyStep2: "Click the <i class='far fa-star'></i> star icon found at the right-hand side of the filter bar",
    deleteFilter: "Delete filter",
    filterNameRequiredError: "Filter name is required",
    existingFilterNameRequiredError: "Please select existing filter from the dropdown below",
    errorUpdatingExistingFilter: "Error updating existing filter. Requested filter is not found",
    save: "Save",
    compare: "Compare",
    saveFilterTitle: "Save a filter",
    saveNewFilter: "Save a new filter",
    updateExistingFilter: "Update an existing filter",
    selectFilterPlaceholder: "Please select",
    filterNamePlaceholder: "Start typing a name",
    expandCategory: "Expand filter category",
    collapseCategory: "Collapse filter category",
    excludeFilter: "Exclude from results",
    includeFilter: "Include in results",
    exportTransactions: "Export transactions",
    xlsReminder: "Reminder: Excel has a 1,048,576 row limit",
    // eslint-disable-next-line sentence-case/sentence-case
    worldpayRm: "Worldpay RM",
    worldpayRmTooltip: "Should the user be allowed to see only Worldpay data (WPG/HCG/Streamline/Worldpay US)?",
    unidentifiedPopover: "MIDs not yet mapped to a business unit in the hierarchy.",
    unidentifiedPopoverManager: "Click the <i class='fal fa-cog'></i> to manage MID mappings",
    // eslint-disable-next-line sentence-case/sentence-case
    packageLevelDisabledPermissionTitle: "Pazien Lite",
    packageLevelDisabledPermissionContent: "Not available in the current package. Contact your sales rep for more info.",
    packageDemoLower: "demo",
    packageView: "View",
    pivot_table_value_warning_add: "Add to values",
    
    cannotRenderTab: `Oops. There was a problem loading this tab.
                      Please try refreshing your browser and if it continues to be an issue, contact us at ${email}`,
    cannotRenderPage: `Oops. There was a problem loading this page.
                      Please try refreshing your browser and if it continues to be an issue, contact us at ${email}`,
    cannotDeleteAllFiles: `Oops. There was a problem deleting all files.
                      Please try refreshing your browser and if it continues to be an issue, contact us at ${email}`,
    
    /**
     * Strip all html tags from a string. Useful for tooltips of formatted data, e.g. amounts
     * @param str
     * @returns {*}
     */
    strip(str) {
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    }
};

// eslint-disable-next-line import/no-default-export
export default strings;
